import React from 'react';
import { Chip } from '@mui/material';

const CONFIG = {
  green: { label: 'On time', color: 'success' },
  amber: { label: 'Borderline', color: 'warning' },
  red: { label: 'Late', color: 'error' },
  not_started: { label: 'Not started', color: 'default' },
};

export default function PunctualityStatusChip({ status }) {
  const cfg = CONFIG[status] || CONFIG.not_started;
  return <Chip size="small" label={cfg.label} color={cfg.color} variant={status === 'not_started' ? 'outlined' : 'filled'} />;
}
